import React from 'react';
import { useCompanySetup } from '../../MasterDataProvider';
import defaultQrCodeTemplate from '../defaultQrCodeTemplate';
import { getInvalidQrTemplateReferences, referencedKeys } from './qrTemplateValidation';
import { resolveTemplateValue } from './resolveTemplateValue';
import { usePreparedContext } from '../usePreparedContext';

export { referencedKeys };

export const useTemplate = () => {
  const companySetup = useCompanySetup();

  const emptyContext = usePreparedContext();

  const templateString = React.useMemo(() => {
    return companySetup.data?.qrCodeTemplate || defaultQrCodeTemplate;
  }, [companySetup.data?.qrCodeTemplate]);

  const invalidReferences = React.useMemo(() => {
    return getInvalidQrTemplateReferences(templateString, emptyContext);
  }, [emptyContext, templateString]);

  const isValid = React.useMemo(() => {
    return invalidReferences?.length === 0;
  }, [invalidReferences?.length]);

  const compile = React.useCallback(
    context => {
      return referencedKeys(templateString)?.reduce?.((acc, path) => {
        const pattern = `{${path}}`;
        const regex = new RegExp(pattern, 'g');
        const raw = resolveTemplateValue(context, path);
        const replacement = raw === undefined || raw === null ? '' : typeof raw === 'object' ? '' : raw;

        acc = acc.replace(regex, replacement);
        return acc;
      }, templateString);
    },
    [templateString]
  );

  return { templateString, isValid, invalidReferences, compile };
};
